import { createMiddleware } from "@tanstack/react-start";
import { getRequestHeaders } from "@tanstack/react-start/server";

export const authMiddlewareServer = createMiddleware({
  type: "function",
}).server(async ({ next }) => {
  const { auth } = await import("../../auth/auth");
  const session = await auth.api.getSession({
    headers: getRequestHeaders(),
  });

  if (!session) {
    throw new Error("Unauthorized");
  }

  return next({
    context: {
      auth: {
        ...session.user,
        userId: session.user.id,
        role: session.user.role as string,
      },
    },
  });
});
